(function () {
  'use strict';

  var ACTION_PHRASES = [
    'should include',
    'should cover',
    'should ensure',
    'steps to take',
    'actions to consider',
    'recommended measures',
    'security controls',
    'best practices',
    'ways to protect',
    'ways to prevent',
    'requirements include',
    'organisations must',
    'businesses must',
    'staff should',
    'employees should',
    'you should'
  ];

  var INTERNAL_CTA_PATH = /^\/(products|collections|pages\/courses)(\/|$)/i;

  var CTA_ICON = [
    '<svg viewBox="0 0 72 72" role="img" aria-label="Online learning">',
    '<path d="M7 25.5 36 10l29 15.5L36 41 7 25.5Z" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>',
    '<path d="M18 32v14c6.2 8.2 29.8 8.2 36 0V32" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>',
    '<path d="M65 26v19" fill="none" stroke="#44b1ff" stroke-width="3" stroke-linecap="round"/>',
    '<circle cx="65" cy="49" r="3" fill="#44b1ff"/>',
    '<path d="M28 25.5h23" fill="none" stroke="#44b1ff" stroke-width="3" stroke-linecap="round"/>',
    '</svg>'
  ].join('');

  function normaliseText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isEmptyElement(element) {
    return !normaliseText(element.textContent) && !element.querySelector('img, video, iframe, a[href]');
  }

  function isFaqHeading(element) {
    if (!element || element.tagName !== 'H2') return false;
    return /^(frequently asked questions|faqs?)$/i.test(normaliseText(element.textContent));
  }

  function isTakeNextStepHeading(element) {
    return Boolean(element && element.tagName === 'H2' && /^take the next step$/i.test(normaliseText(element.textContent)));
  }

  function isInternalCtaLink(link) {
    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      return url.origin === window.location.origin && INTERNAL_CTA_PATH.test(url.pathname);
    } catch (error) {
      return false;
    }
  }

  function markChecklists(container) {
    Array.prototype.slice.call(container.querySelectorAll('ul')).forEach(function (list) {
      if (list.closest('.dpg-blog-checklist, .dpg-blog-faq')) return;

      var items = Array.prototype.filter.call(list.children, function (child) {
        return child.tagName === 'LI';
      });
      var introduction = list.previousElementSibling;
      if (!introduction || items.length < 3) return;

      var text = normaliseText(introduction.textContent).toLowerCase();
      var explicit = /^important checklist\s*:/.test(text);
      var actionFocused = ACTION_PHRASES.some(function (phrase) {
        return text.indexOf(phrase) !== -1;
      });
      if (!explicit && !actionFocused) return;

      var panel = document.createElement('section');
      panel.className = 'dpg-blog-checklist';
      panel.setAttribute('aria-label', explicit ? 'Important checklist' : 'Recommended actions');
      panel.dataset.dpgClassification = explicit ? 'explicit' : 'action-rule';

      introduction.parentNode.insertBefore(panel, introduction);
      panel.appendChild(introduction);
      panel.appendChild(list);
      introduction.classList.add('dpg-blog-checklist__heading');
      list.classList.add('dpg-blog-checklist__list');
    });
  }

  function markGridLists(container) {
    Array.prototype.slice.call(container.querySelectorAll('ul, ol')).forEach(function (list) {
      if (list.closest('.dpg-blog-checklist, .dpg-blog-cta')) return;
      list.classList.add('dpg-blog-grid-list');
      list.classList.add(list.tagName === 'OL' ? 'dpg-blog-grid-list--numbered' : 'dpg-blog-grid-list--bulleted');
    });
  }

  function capitaliseFirstLetter(element) {
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.parentElement || node.parentElement.closest('script, style')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      var match = node.nodeValue.match(/[a-z]/i);
      if (!match) continue;
      var index = match.index;
      var letter = node.nodeValue.charAt(index);
      var upper = letter.toUpperCase();
      if (letter !== upper) {
        node.nodeValue = node.nodeValue.slice(0, index) + upper + node.nodeValue.slice(index + 1);
      }
      return;
    }
  }

  function enforceListSentenceCase(container) {
    container.querySelectorAll('.dpg-blog-grid-list > li, .dpg-blog-checklist__list > li').forEach(capitaliseFirstLetter);
  }

  function wrapFinalCta(container) {
    var children = Array.prototype.slice.call(container.children);
    var explicitHeading = children.find(isTakeNextStepHeading);

    if (explicitHeading) {
      var explicitPanel = document.createElement('section');
      explicitPanel.className = 'dpg-blog-cta dpg-blog-cta--explicit';
      explicitPanel.setAttribute('aria-label', 'Take the next step');
      explicitHeading.parentNode.insertBefore(explicitPanel, explicitHeading);

      var current = explicitHeading;
      while (current) {
        var next = current.nextElementSibling;
        explicitPanel.appendChild(current);
        current = next;
      }
      return explicitPanel;
    }

    var faqIndex = children.findIndex(isFaqHeading);
    if (faqIndex === -1) return null;

    var candidate = null;
    for (var index = children.length - 1; index > faqIndex; index -= 1) {
      var element = children[index];
      if (isEmptyElement(element)) continue;
      var hasCourseLink = Array.prototype.some.call(element.querySelectorAll('a[href]'), isInternalCtaLink);
      if (hasCourseLink) candidate = element;
      break;
    }

    if (!candidate) return null;

    var inferredPanel = document.createElement('section');
    inferredPanel.className = 'dpg-blog-cta dpg-blog-cta--inferred';
    inferredPanel.setAttribute('aria-label', 'Recommended DPG training');
    candidate.parentNode.insertBefore(inferredPanel, candidate);
    inferredPanel.appendChild(candidate);
    return inferredPanel;
  }

  function findCtaButtonOverride(panel) {
    var elements = Array.prototype.slice.call(panel.querySelectorAll('p, span, div'));
    for (var index = 0; index < elements.length; index += 1) {
      var element = elements[index];
      if (element.children.length) continue;
      var match = normaliseText(element.textContent).match(/^cta button(?: text)?\s*:\s*(.+)$/i);
      if (match && normaliseText(match[1])) return normaliseText(match[1]);
    }
    return '';
  }

  function titleFromCourseLink(link) {
    var label = normaliseText(link && link.textContent);
    var genericLabel = /^(view|browse|explore|start|enrol|enroll|see|visit|learn more)(\s+(the|this|our))?\s*(course|courses|training|programme|program)?(\s+now)?$/i;
    if (label && !genericLabel.test(label)) return label;

    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      var parts = url.pathname.split('/').filter(Boolean);
      var handle = parts[parts.length - 1] || '';
      return handle
        .replace(/[-_]+/g, ' ')
        .replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
    } catch (error) {
      return label;
    }
  }

  function prepareCtaCopy(panel) {
    var copy = panel.cloneNode(true);

    Array.prototype.slice.call(copy.querySelectorAll('p, span, div')).forEach(function (element) {
      if (!element.children.length && /^cta button(?: text)?\s*:/i.test(normaliseText(element.textContent))) {
        element.remove();
      }
    });

    Array.prototype.slice.call(copy.querySelectorAll('h2, h3')).forEach(function (heading) {
      if (isTakeNextStepHeading(heading)) heading.remove();
    });

    Array.prototype.slice.call(copy.querySelectorAll('a[href]')).forEach(function (link) {
      var label = normaliseText(link.textContent);
      if (!label) {
        link.remove();
        return;
      }
      if (!isInternalCtaLink(link)) {
        link.replaceWith(document.createTextNode(label));
        return;
      }

      var previous = link.previousSibling;
      if (!previous || previous.nodeType !== Node.TEXT_NODE) {
        link.parentNode.insertBefore(document.createTextNode(' '), link);
      } else if (!/\s$/.test(previous.nodeValue)) {
        previous.nodeValue += ' ';
      }

      var next = link.nextSibling;
      if (!next || next.nodeType !== Node.TEXT_NODE) {
        link.parentNode.insertBefore(document.createTextNode(' '), link.nextSibling);
      } else if (!/^\s/.test(next.nodeValue)) {
        next.nodeValue = ' ' + next.nodeValue;
      }
    });

    return copy;
  }

  function enhanceCtaPanel(panel) {
    if (!panel || panel.dataset.dpgCtaReady === 'true') return;

    var links = Array.prototype.slice.call(panel.querySelectorAll('a[href]'));
    var primaryLinkIndex = links.findIndex(function (link) {
      return isInternalCtaLink(link) && normaliseText(link.textContent);
    });
    if (primaryLinkIndex === -1) {
      primaryLinkIndex = links.findIndex(isInternalCtaLink);
    }

    var primaryLink = primaryLinkIndex >= 0 ? links[primaryLinkIndex] : null;
    var buttonLabel = findCtaButtonOverride(panel) || 'View Course';
    var copy = prepareCtaCopy(panel);
    var layout = document.createElement('div');
    layout.className = 'dpg-blog-cta__layout';

    panel.setAttribute('aria-label', 'Take the Next Step');

    var icon = document.createElement('div');
    icon.className = 'dpg-blog-cta__icon';
    icon.innerHTML = CTA_ICON;
    layout.appendChild(icon);

    var content = document.createElement('div');
    content.className = 'dpg-blog-cta__content';

    var title = document.createElement('h2');
    title.className = 'dpg-blog-cta__title';
    title.textContent = 'Take the Next Step';
    content.appendChild(title);

    if (!isEmptyElement(copy)) {
      var body = document.createElement('div');
      body.className = 'dpg-blog-cta__text';
      while (copy.firstChild) body.appendChild(copy.firstChild);
      content.appendChild(body);
    }
    layout.appendChild(content);

    if (primaryLink) {
      var action = document.createElement('div');
      action.className = 'dpg-blog-cta__action';
      var button = primaryLink.cloneNode(true);
      button.className = 'dpg-blog-cta__button';
      button.textContent = buttonLabel;
      if (button.target === '_blank') button.rel = 'noopener';
      action.appendChild(button);
      layout.appendChild(action);
    }

    panel.innerHTML = '';
    panel.appendChild(layout);
    panel.dataset.dpgCtaReady = 'true';
  }

  function nodesBetween(start, boundary) {
    var result = [];
    var current = start.nextElementSibling;
    while (current && current !== boundary) {
      if (current.tagName === 'H2') break;
      result.push(current);
      current = current.nextElementSibling;
    }
    return result;
  }

  function enhanceHeadingFaq(faqHeading, sectionNodes) {
    var questionHeadings = sectionNodes.filter(function (element) {
      return element.tagName === 'H3' && /\?\s*$/.test(normaliseText(element.textContent));
    });
    if (questionHeadings.length < 2) return false;

    var groups = questionHeadings.map(function (question, questionIndex) {
      var answerNodes = [];
      var current = question.nextElementSibling;
      var nextQuestion = questionHeadings[questionIndex + 1] || null;
      while (current && current !== nextQuestion && sectionNodes.indexOf(current) !== -1) {
        if (current.tagName === 'H2' || (current.tagName === 'H3' && /\?\s*$/.test(normaliseText(current.textContent)))) break;
        answerNodes.push(current);
        current = current.nextElementSibling;
      }
      return {
        question: question,
        answers: answerNodes.filter(function (node) { return !isEmptyElement(node); })
      };
    });

    if (groups.some(function (group) { return group.answers.length === 0; })) return false;

    var faq = document.createElement('div');
    faq.className = 'dpg-blog-faq';
    questionHeadings[0].parentNode.insertBefore(faq, questionHeadings[0]);

    groups.forEach(function (group) {
      var details = document.createElement('details');
      details.className = 'dpg-blog-faq__item';
      var summary = document.createElement('summary');
      summary.className = 'dpg-blog-faq__question';
      summary.innerHTML = group.question.innerHTML;
      var answer = document.createElement('div');
      answer.className = 'dpg-blog-faq__answer';
      group.answers.forEach(function (node) { answer.appendChild(node); });
      details.appendChild(summary);
      details.appendChild(answer);
      faq.appendChild(details);
      group.question.remove();
    });

    faqHeading.classList.add('dpg-blog-faq__title');
    return true;
  }

  function enhanceLegacyFaq(faqHeading, sectionNodes) {
    var entries = sectionNodes.filter(function (element) {
      if (element.tagName !== 'P') return false;
      var strong = element.querySelector(':scope > strong');
      return Boolean(strong && /\?\s*$/.test(normaliseText(strong.textContent)));
    });
    if (entries.length < 2) return false;

    var prepared = entries.map(function (paragraph) {
      var strong = paragraph.querySelector(':scope > strong');
      var answerParagraph = paragraph.cloneNode(true);
      var answerStrong = answerParagraph.querySelector(':scope > strong');
      if (answerStrong) answerStrong.remove();
      while (answerParagraph.firstChild) {
        var first = answerParagraph.firstChild;
        if (first.nodeType === Node.TEXT_NODE && !normaliseText(first.textContent)) {
          first.remove();
        } else if (first.nodeType === Node.ELEMENT_NODE && first.tagName === 'BR') {
          first.remove();
        } else {
          break;
        }
      }
      return { paragraph: paragraph, questionHtml: strong.innerHTML, answer: answerParagraph };
    });

    if (prepared.some(function (item) { return !normaliseText(item.answer.textContent); })) return false;

    var faq = document.createElement('div');
    faq.className = 'dpg-blog-faq';
    prepared[0].paragraph.parentNode.insertBefore(faq, prepared[0].paragraph);

    prepared.forEach(function (item) {
      var details = document.createElement('details');
      details.className = 'dpg-blog-faq__item';
      var summary = document.createElement('summary');
      summary.className = 'dpg-blog-faq__question';
      summary.innerHTML = item.questionHtml;
      var answer = document.createElement('div');
      answer.className = 'dpg-blog-faq__answer';
      answer.appendChild(item.answer);
      details.appendChild(summary);
      details.appendChild(answer);
      faq.appendChild(details);
      item.paragraph.remove();
    });

    faqHeading.classList.add('dpg-blog-faq__title');
    return true;
  }

  function enhanceSpanFaq(faqHeading, sectionNodes) {
    var entries = sectionNodes.filter(function (element) {
      if (element.tagName !== 'P' || !element.firstElementChild || element.firstElementChild.tagName !== 'SPAN') return false;
      var question = normaliseText(element.firstElementChild.textContent);
      var fullText = normaliseText(element.textContent);
      return /\?\s*$/.test(question) && fullText.length > question.length;
    });
    if (entries.length < 2) return false;

    var prepared = entries.map(function (paragraph) {
      var questionSpan = paragraph.firstElementChild;
      var answerParagraph = paragraph.cloneNode(true);
      answerParagraph.firstElementChild.remove();
      return {
        paragraph: paragraph,
        questionHtml: questionSpan.innerHTML,
        answer: answerParagraph
      };
    });

    if (prepared.some(function (item) { return !normaliseText(item.answer.textContent); })) return false;

    var faq = document.createElement('div');
    faq.className = 'dpg-blog-faq';
    prepared[0].paragraph.parentNode.insertBefore(faq, prepared[0].paragraph);

    prepared.forEach(function (item) {
      var details = document.createElement('details');
      details.className = 'dpg-blog-faq__item';
      var summary = document.createElement('summary');
      summary.className = 'dpg-blog-faq__question';
      summary.innerHTML = item.questionHtml;
      var answer = document.createElement('div');
      answer.className = 'dpg-blog-faq__answer';
      answer.appendChild(item.answer);
      details.appendChild(summary);
      details.appendChild(answer);
      faq.appendChild(details);
      item.paragraph.remove();
    });

    faqHeading.classList.add('dpg-blog-faq__title');
    return true;
  }

  function enhancePairedParagraphFaq(faqHeading, sectionNodes) {
    var prepared = [];
    for (var index = 0; index < sectionNodes.length - 1; index += 1) {
      var question = sectionNodes[index];
      var answer = sectionNodes[index + 1];
      if (question.tagName !== 'P' || answer.tagName !== 'P') continue;
      if (!/\?\s*$/.test(normaliseText(question.textContent))) continue;
      if (/\?\s*$/.test(normaliseText(answer.textContent)) || isEmptyElement(answer)) continue;
      prepared.push({ question: question, answer: answer });
      index += 1;
    }
    if (prepared.length < 2) return false;

    var faq = document.createElement('div');
    faq.className = 'dpg-blog-faq';
    prepared[0].question.parentNode.insertBefore(faq, prepared[0].question);

    prepared.forEach(function (item) {
      var details = document.createElement('details');
      details.className = 'dpg-blog-faq__item';
      var summary = document.createElement('summary');
      summary.className = 'dpg-blog-faq__question';
      summary.innerHTML = item.question.innerHTML;
      var answer = document.createElement('div');
      answer.className = 'dpg-blog-faq__answer';
      answer.appendChild(item.answer);
      details.appendChild(summary);
      details.appendChild(answer);
      faq.appendChild(details);
      item.question.remove();
    });

    faqHeading.classList.add('dpg-blog-faq__title');
    return true;
  }

  function enhanceFaq(container, ctaPanel) {
    var faqHeading = Array.prototype.find.call(container.children, isFaqHeading);
    if (!faqHeading) return;
    var sectionNodes = nodesBetween(faqHeading, ctaPanel);
    if (enhanceHeadingFaq(faqHeading, sectionNodes)) return;
    if (enhanceLegacyFaq(faqHeading, sectionNodes)) return;
    if (enhanceSpanFaq(faqHeading, sectionNodes)) return;
    enhancePairedParagraphFaq(faqHeading, sectionNodes);
  }

  function initialise(container) {
    if (container.dataset.dpgBlogReady === 'true') return;
    container.dataset.dpgBlogReady = 'true';
    markChecklists(container);
    markGridLists(container);
    var ctaPanel = wrapFinalCta(container);
    enhanceFaq(container, ctaPanel);
    enhanceCtaPanel(ctaPanel);
    enforceListSentenceCase(container);
  }

  function initialiseAll() {
    document.querySelectorAll('.mh_blog_content_main.dpg-blog-enhancements').forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }
})();
